import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import InfiniteFetchList from './InfiniteFetchList';
import DiscussionListHeader from './DiscussionListHeader';
import DiscussionCard from './DiscussionCard';
import DiscussionRow from './DiscussionRow';

export default class DiscussionList extends Component {
  static propTypes = {
    perPage: PropTypes.number.isRequired,
    apiUrl: PropTypes.string.isRequired,
    ontology: PropTypes.object.isRequired,
    currentCommunity: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      population: PropTypes.number.isRequired,
    }).isRequired,
    currentUser: PropTypes.object.isRequired,
    currentUserIsStaff: PropTypes.bool.isRequired,
    apiUserUrl: PropTypes.string,
    apiCompanyUrl: PropTypes.string,
    noResultsMessage: PropTypes.string,
    selectedOption: PropTypes.string,
  };

  static defaultProps = {
    noResultsMessage: 'No discussions available. You can always create one!',
    apiUserUrl: '',
    apiCompanyUrl: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      expanded: this.props.expanded,
    };
  }

  componentDidMount() {
    this.unlistenParamsChange = router.listen(this.handleParamsChange);
  }

  componentWillUnmount() {
    this.unlistenParamsChange();
  }

  handleParamsChange = () => {
    const params = qs.parse(window.location.search.slice(1));

    if ((params.expanded === 'true') != this.state.expanded) {
      this.setState({
        expanded: params.expanded === 'true',
      });
    }
  };

  renderItem = (item, key) => {
    if (this.state.expanded) {
      return <DiscussionCard key={item.url} {...item} />;
    }
    return <DiscussionRow key={item.url} {...item} />;
  }

  renderList() {
    return (
      <InfiniteFetchList
        apiUrl={this.props.apiUrl}
        perPage={this.props.perPage}
        itemRenderer={this.renderItem}
        loadingCardsAnimation={this.state.expanded}
        asTable={!this.state.expanded}
        subscribeTo={{
          channel: 'DiscussionsChannel',
          community_id: this.props.currentCommunity.id,
        }}
        noResultsMessage={this.props.noResultsMessage}
      />
    );
  }

  renderCompactList() {
    return (
      <div className="u-bg-white u-rounded u-px-4 u-pt-0 u-shadow u-border u-border-grey-light u-mb-8">
        <table className="u-border-0 u-mb-0 u-w-full">
          <colgroup>
            <col width="100%" />
            <col width="0%" />
            <col width="0%" />
            <col width="0%" />
            <col width="0%" />
          </colgroup>
          <thead className="u-hidden md:u-table-header-group">
            <tr className="u-bg-white u-border-b u-border-grey-light u-uppercase u-text-sm u-font-semibold">
              <th className="u-pt-2 u-pb-1 u-pl-0">Title</th>
              <th className="u-pt-2 u-pb-1">
                <i className="Icon-views" />
              </th>
              <th className="u-pt-2 u-pb-1">
                <i className="Icon-comment" />
              </th>
              <th className="u-pt-2 u-pb-1">
                <i className="Icon-clock" />
              </th>
              <th className="u-pt-2 u-pb-1 u-w-28 u-px-0">Participants</th>
            </tr>
          </thead>
          {this.renderList()}
        </table>
      </div>
    );
  }

  render() {
    return (
      <>
        <DiscussionListHeader
          currentCommunityName={this.props.currentCommunity.name}
          currentCommunityPopulation={this.props.currentCommunity.population}
          currentUser={this.props.currentUser}
          currentUserIsStaff={this.props.currentUserIsStaff}
          ontology={this.props.ontology}
          apiUrl={this.props.apiUrl}
          apiUserUrl={this.props.apiUserUrl}
          apiCompanyUrl={this.props.apiCompanyUrl}
          expanded={this.state.expanded}
          selectedOption={this.props.selectedOption}
          sortItems={this.props.sortItems}
          sortOptions={this.props.sortOptions}
        />
        {this.state.expanded && this.renderList()}
        {!this.state.expanded && this.renderCompactList()}
      </>
    );
  }
}
